module.exports = __webpack_public_path__ + "static/Feature1-3fb56198b8bce98ed013bf9305a062bf.jpg";